module.exports = __webpack_public_path__ + "img/photo.c08f6bcd.jpg";